<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un puesto jurídico</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los puestos jurídico</option>
        <option v-for="PuestoJuridico in PuestosJuridicos" :key="PuestoJuridico.PuestoJuridicoId" :value="PuestoJuridico.PuestoJuridicoId">{{PuestoJuridico.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        PuestosJuridicos:[],
        idDelModelo:null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput:String,
      valorDefinido:Number,
      parametros:Object,
    },
    mounted(){     
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const params = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
        this.$store.dispatch("A_PJ_Catalogo_Establecer005PuestoJuridico", params);
    },
    created(){
      this.cargaCatalogoPuestosJuridicos();
    },
    methods:{
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;

        const params = {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_PJ_Catalogo_Establecer005PuestoJuridico", params);
        this.$emit("valorParaElPadre", evento);
      },
      cargaCatalogoPuestosJuridicos(){
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba
                 
        axios.post(api.conexion + api.PJ.catalogos.C005PuestosJuridicos, this.parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.error(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {                                              
              this.PuestosJuridicos = respuesta.data.PuestosJuridicos;
            }
          })
          .catch(excepcion => 
          {
            console.error(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      }
    }    
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/005PuestoJuridico.vue